import React from "react";
import Banner from "../../components/Banner/Banner";
import BestSellers from "../../components/home/BestSellers/BestSellers";
import NewArrivals from "../../components/home/NewArrivals/NewArrivals";
import SpecialOffers from "../../components/home/SpecialOffers/SpecialOffers";
import Cards from "../../components/home/midInfo";
import QualityAndServiceSection from "../../components/home/rating";
import Banner2 from "../../components/Banner/Banner2";
import Banner1 from "../../components/Banner/Banner1";
import Banner3 from "../../components/Banner/Banner3";
import Banner4 from "../../components/Banner/Banner4";
import Banner5 from "../../components/Banner/Banner5";
import Banner6 from "../../components/Banner/Banner6";
import Banner7 from "../../components/Banner/Banner7";
import Banner8 from "../../components/Banner/Banner8";
import Banner9 from "../../components/Banner/Banner9";
import Banner10 from "../../components/Banner/Banner10";
import Banner11 from "../../components/Banner/Banner11";
import Banner12 from "../../components/Banner/Banner12";

const Home = () => {
  return (
    <div className="w-full mx-auto">
      <Banner6></Banner6>
      <Banner9></Banner9>
      <div className=" mx-auto">
      <SpecialOffers />
      </div>
      <Banner7></Banner7>
      <Banner8></Banner8>
      {/* <Banner11></Banner11> */}
      <NewArrivals />
      <Banner5></Banner5>
      <Banner12></Banner12>
      <Banner10></Banner10>
      <BestSellers />
      {/* <Banner3></Banner3>
      <Banner4></Banner4>   */}
      {/* <BannerBottom /> */}
      <div className=" mx-auto">
      
        {/* <Banner2></Banner2>
        <Banner1></Banner1> */}
        {/* <Cards /> */}
        <QualityAndServiceSection />
      </div>
    </div>
  );
};

export default Home;
